<template>
  <div class="card-container card-container-padding">
    <BaseElFormItem label="選擇餐廳">
      <BaseElSelect
        v-model="context.foodpandaRestaurant"
        :filterable="false"
        clearable
        :placeholder="placeholder"
        :loading="loading"
        value-key="id"
        @change="onRestaurantChange"
      >
        <BaseElSelectOption
          v-for="item in restaurantList"
          :key="item.id"
          :label="formatRestaurantLabel(item)"
          :value="item"
        />
      </BaseElSelect>
    </BaseElFormItem>
  </div>
</template>

<script>
import { FindMemberCustomProfile } from '@/api/memberCustomProfile'
import { useShop } from '@/use/shop'
import { useCreateAppointment } from '@/use/useCreateAppointment'
import { get } from 'lodash'
import { ref, computed, onMounted, watch } from 'vue'

export default {
  name: 'AppointmentRestaurantBlock',
  props: {
    placeholder: { type: String, default: '請選擇餐廳' },
  },
  setup (props, { emit }) {
    const { shopId } = useShop()
    const loading = ref(false)
    const restaurantList = ref([])

    const { context, allCartItemReady, refreshOrderPrice } = useCreateAppointment()

    const memberId = computed(() => {
      return get(context.member, 'id')
    })
    const formatRestaurantLabel = (item) => {
      const name = item.info?.foodpandaRestaurant?.name || ''
      const address = item.info?.foodpandaRestaurant?.address || ''
      return `${name}（${address}）`
    }

    const getRestaurant = async () => {
      try {
        loading.value = true
        const [res, error] = await FindMemberCustomProfile({
          shopId: shopId.value,
          type: 'foodpandaRestaurant',
          MemberId: memberId.value,
        })
        if (error) {
          restaurantList.value = []
        } else {
          restaurantList.value = res
        }
      } catch (e) {
        restaurantList.value = []
      } finally {
        loading.value = false
      }
    }

    // 預設載入全部
    onMounted(async () => {
      await getRestaurant()
      if (context.foodpandaRestaurant && get(context.foodpandaRestaurant, 'id')) {
        const match = restaurantList.value.find(
          (item) => item.id === context.foodpandaRestaurant.id,
        )
        if (match) {
          context.foodpandaRestaurant = match
        } else {
          restaurantList.value.push(context.foodpandaRestaurant)
        }
      }
    })

    // memberId 變動時自動重新查詢
    watch(
      memberId,
      (val) => {
        if (!val) return
        getRestaurant({ MemberId: val })
      },
      { immediate: true },
    )

    const onRestaurantChange = () => {
      if (allCartItemReady.value) {
        refreshOrderPrice()
      }
    }

    return {
      restaurantList,
      loading,
      getRestaurant,
      formatRestaurantLabel,
      context,
      onRestaurantChange,
    }
  },
}
</script>

<style lang="postcss" scoped>
.card-container-padding {
  @apply !p-5 !pl-[30px];
}
</style>
